import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoading = new Subject<boolean>();

  constructor() {}

  loading() {
    // uses of setTimeout to avoid an error 'ExpressionChangedAfterItHasBeenCheckedError'
    setTimeout(() => {
      this.isLoading.next(true);
    });
  }
  loaded() {
    this.isLoading.next(false);
  }
}
